import { useRef } from "react";
import { StyledAuth } from "./style";
import { MyButton, MyText } from "../../components";
import { Col, Flex, Input, Row, message, Grid, Form } from "antd";
import { LogoIcon } from "../../assets";
import { useState, useEffect, useCallback } from "react";
import { KeyOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { LANG_KEY } from "../../utils/constants/language";
import { MySegmented } from "../../components";
import { useNavigate } from 'react-router-dom';
import { useDispatch , useSelector} from 'react-redux';
import {useTranslation} from "react-i18next";
import {fetchAuth, fetchModules, ROUTE_PATH, selectStore } from "../../utils/"
import { useLang } from "../../utils/context/lang";
import ReCAPTCHA from "react-google-recaptcha";
import { COOKIE_KEY } from "../../utils/";
import {Cookies} from "react-cookie";
import { useEmbeddedLink } from "../../utils/context/embed";
import { setTokenCookie } from "../../utils/";
import { useEmbeddedNavigate } from "../../utils/context/embed";
const FORM_NAME = {
  email: 'email',
  phone: 'phone',
};



export const ExpiredPasswordPage = () => {
  const {t} = useTranslation("common")
  const {profile: {userProfile: userProfileState}} = useSelector(selectStore)
  const {handleChangeLang, lang} = useLang()
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const [form] = Form.useForm();
  
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [currentKey, setCurrentKey] = useState<string>(FORM_NAME.email);
  const [isFormComplete, setIsFormComplete] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const embeddedLink = useEmbeddedLink();
    const [formData, setFormData] = useState({
        email: '',
        phone: '',
        username: '',
        password: '',
        type: 1,
        password_repeat: '',
    });

  const cookies = new Cookies()

  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);

  const handleChangeLangSelect = useCallback((value: any) => {
      handleChangeLang(value)
    }, [])

    const handleInputChange = (e) => {
        let { name, value } = e.target;
    
        if (name === "phone") {
        let cleanedValue = value.replace(/\D/g, "");
        
        if (cleanedValue.length > 11) {
            cleanedValue = cleanedValue.slice(0, 11);
        }
    
        setFormData((prevState) => ({
            ...prevState,
            [name]: cleanedValue,
            // username: isAnonymous ? cleanedValue : prevState.username,
            // type: isAnonymous ? 2 : 1,
        }));
    
        } else {
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        }
    }; 

  const handleLogin = async () => {
  try {
    let username = currentKey === FORM_NAME.email ? email : phone;

    if (currentKey === FORM_NAME.phone) {
      username = phone.replace(/\D/g, "");
      username = `${username}`; 
    }

    await dispatch(fetchAuth({ username, password }));
  } catch (error) {
  }
};

const isFormValid = () => {
    const { password, password_repeat } = formData;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  
  
    const isPasswordValid = passwordRegex.test(password) && password === password_repeat;
  
    return isPasswordValid;
  };


  useEffect(() => {
    setIsFormComplete(isFormValid());
  }, [formData]);

useEffect(() => {
  if (userProfileState?.data?.message && userProfileState?.data?.status === "error") {
    message.error(userProfileState.data.message);
  }
}, [userProfileState]);

  useEffect(() => {
    if (userProfileState?.success && !userProfileState?.loading && token) {
      embeddedNavigate('/');
    } else if (!userProfileState?.success && !userProfileState?.loading && userProfileState?.failed) {
      // message.error(t("loginError"));
    }
  }, [userProfileState, token]);

  return (
    <StyledAuth>
      <div style={{ position: 'absolute', top: screens.xs ? 15: 40, right: 40 }}>
        <MySegmented
          onChange={(value) => handleChangeLangSelect(value)}
          value={lang}
          options={[
          { label: 'ҚАЗ', value: LANG_KEY.KZ },
          { label: 'РУС', value: LANG_KEY.RU },
            ]}
          />
      </div>

      <Flex justify="center" align="center" style={{ width: 500 }}>
        <Row justify="center" gutter={[16, 16]}>
          <Col>
          <Link to={embeddedLink(ROUTE_PATH.MAIN)} style={{ display: 'flex' }}>
          <LogoIcon />
              </Link>

          </Col>
          <Col>
            <MyText color="rgba(76, 76, 77, 1)" weight={600} size={screens.xs ? 15 : 18} lineHeight={screens.xs ? '20px' : '32px'}>
              {t("passwordExpired")}
            </MyText>
          </Col>
<Form form={form} style={{marginTop: 16}}>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              
<Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    {t("createPassword")}

                  </MyText>
                  <Form.Item
                    name="password"
                    labelCol={{ span: 24 }}
                    style={{ marginTop: 8 }}
                    rules={[
                        { required: true, message: t("enterPassword") },
                        ({ getFieldValue }) => ({
                        validator(_, value) {
                            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
                            if (value && !passwordRegex.test(value)) {
                            return Promise.reject(t("passwordRegex"));
                            }
                            return Promise.resolve();
                        },
                        }),
                    ]}
                    >
                    <Input.Password
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        prefix={<KeyOutlined style={{ color: '#969BAB', marginRight: 8 }} />}
                        placeholder={t("enterPassword")}                      
                    />
                    </Form.Item>
                </Col>
                <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    {t("repeatPassword")} 
                  </MyText>
                  <Form.Item labelCol={{ span: 24 }} style={{ marginTop: 8 }} rules={[{ required: true, message: t("repeatPassword") }]}>
                    <Input.Password
                      name="password_repeat"
                      value={formData.password_repeat}
                      onChange={handleInputChange}
                      prefix={<KeyOutlined style={{ color: '#969BAB' , marginRight: 8 }} />}
                      placeholder={t("enterPassword")}
                    />
                  </Form.Item>
                </Col>

              <Col span={24}>
                <MyButton
                  type="primary"
                  htmlType="submit"
                  color="orange"
                  style={{ width: '100%', fontSize: '18px' }}
                  onClick={handleLogin}
                  disabled={!isFormComplete}

                >
                  {t("login")}
                </MyButton>
              </Col>
            </Row>
          </Col>
          </Form>
        </Row>
      </Flex>
    </StyledAuth>
  );
};
